<!--
 * @Author: baiwei
 * @Date: 2020-02-26 09:58:34
 * @LastEditors: baiwei
 * @LastEditTime: 2020-04-20 14:04:31
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div class="nodata-pack">
        <i class="nodata-img"></i>
        <span class="nodata-msg">{{value || $t('暂无数据')}}</span>
    </div>
</template>

<script>
export default {
    name: 'customNodata',
    props: ['value'],
    data () {
        return {
        }
    }
}
</script>
<style lang="less" scoped>
.nodata-pack{
    padding: 30px;
}
</style>
